/**
 * Sub-rect de la imagen natural que, dibujado a `dest` completo, reproduce
 * CSS `object-fit:cover` + `object-position` (pos en % 0..100).
 */
export function coverSourceRect(
  natural: { w: number; h: number },
  dest: { w: number; h: number },
  pos: { x: number; y: number },
): { sx: number; sy: number; sw: number; sh: number } {
  const scale = Math.max(dest.w / natural.w, dest.h / natural.h);
  const sw = dest.w / scale;
  const sh = dest.h / scale;
  const sx = ((natural.w - sw) * pos.x) / 100;
  const sy = ((natural.h - sh) * pos.y) / 100;

  return { sx, sy, sw, sh };
}

/** Timestamps (s) de cada frame: paso 1/fps, recortado a min(duracion, cap). */
export function frameTimes(durationSec: number, fps: number, maxSeconds: number): number[] {
  const total = Math.min(durationSec, maxSeconds);
  const count = Math.max(1, Math.floor(total * fps));

  return Array.from({ length: count }, (_, i) => i / fps);
}
